module.exports = __webpack_public_path__ + "static/img/day-2.23625e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/day-2.png
// module id = hyLl
// module chunks = 1